<template>
  <div style="width: 560px;">
    <a-alert :show-icon="true" type="warning">
      <template #message>
        <div>* 单个水印组允许添加 1 ~ 6 个水印，组内添加的水印将同时作用于直播照片</div>
        <div>* 系统根据上传摄影师自动生成【LOGO + 昵称】的水印且作用于所有直播照片</div>
        <div>* 可根据使用情况添加多个水印组，多个水印组将根据权重值按比例分别作用于直播照片。如：组A的权重值为50，组B的权重值为100，则1/3直播照片水印为组A，另外2/3直播照片水印为组B</div>
      </template>
    </a-alert>
    <template v-if="!album.privilege['no_copyright']">
      <div style="margin:20px 0 -34px 0;text-align:right;z-index:900;position:relative;">
        <a-button type="primary" ghost shape="round" icon="pay-circle" @click="payWatermark">去平台水印</a-button>
      </div>
      <WatermarkPrivilege ref="watermarkPrivilege" :album-id="album.id" :user="user"/>
    </template>
    <a-tabs :animated="false" style="margin-top: 15px;">
      <a-tab-pane :key="1" tab="自定义水印配置">
        <a-spin :spinning="searching" style="margin-top: 5px;">
          <template v-if="result.total">
            <div :key="item.id" class="image-box" v-for="item in result.data">
              <img :src="previewUrl(item)" alt="" height="184"/>
              <div style="padding: 20px;">
                <div style="margin-bottom: 8px;">组权重值：</div>
                <a-input-number
                    :min="1" @blur="setWeight(item, false)" @change="setWeight(item, true)" class="link-input"
                    placeholder="请输入水印组权重" style="margin-bottom: 50px; width: 100%" v-model="item.config.weight"/>
                <a-space :size="20">
                  <a-button @click="update(item)" icon="edit" shape="round">编辑</a-button>
                  <a-popconfirm @confirm="remove(item)" title="您确定要删除吗？">
                    <a-button icon="delete" shape="round" type="danger">删除</a-button>
                  </a-popconfirm>
                </a-space>
              </div>
            </div>
            <a-button @click="create" block icon="plus" size="large" style="background: #fafafa;" type="dashed">添加水印组
            </a-button>
          </template>
          <a-empty description="暂未添加水印" style="margin: 30px 0;" v-else>
            <a-button @click="create" icon="plus" shape="round" type="primary">立即添加</a-button>
          </a-empty>
        </a-spin>
        <WatermarkForm :album="album" :preview="{width: 552, height: 313}" @saved="refresh" ref="watermarkForm"/>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="平台LOGO + 摄影师昵称" v-if="!album.privilege['no_copyright']">
        <CopyrightForm :album="album" :preview="{width: 552, height: 313}"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import api from "../../../../utils/api";
import WatermarkForm from "./comps/WatermarkForm";
import CopyrightForm from "./comps/CopyrightForm";
import WatermarkPrivilege from "./comps/WatermarkPrivilege";

export default {
  name: "Watermark",
  props: {
    user: Object,
    album: Object,
  },
  components: {WatermarkPrivilege, CopyrightForm, WatermarkForm},
  data() {
    return {
      result: {
        total: 0,
        data: [],
      },
      timeId: null,
      searching: false,
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    create() {
      this.$refs.watermarkForm.open();
    },
    update(item) {
      this.$refs.watermarkForm.open(item);
    },
    remove(item) {
      api.v1.album.watermark.delete(this.album.id, item.id).then(this.refresh);
    },
    setWeight(item, delay) {
      let saveFunc = () => {
        api.v1.album.watermark.update(this.album.id, item.id, item.config);
      };
      clearTimeout(this.timeId);
      this.timeId = setTimeout(saveFunc, delay ? 3000 : 0);
    },
    previewUrl(watermark) {
      return api.v1.resource.watermarkPreview(watermark.id) + '?v=' + (new Date().getTime());
    },
    refresh() {
      this.searching = true;
      api.v1.album.watermark.search(this.album.id)
          .then(res => this.result = res)
          .finally(() => this.searching = false);
    },
    payWatermark() {
      this.$refs.watermarkPrivilege.open();
    }
  }
}
</script>

<style lang="less" scoped>
.image-box {
  display: flex;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px #e8e8e8 solid;
  position: relative;
}
</style>
